import Modal from "../../ui/Modal";
import Form from "../../ui/Form";
import { useCreateCarInfoMutation, useUpdateCarInfoMutation } from "../../utils/carInfo.utils";
import { useGetAllCarInfoTypeQuery } from "../../utils/carInfoType.utils";
import { optionGen } from "../../utils/form.utils";
import CarInfoParentField from "./CarInfoParentField";

export default function CarInfoAddEdit({ modal, toggle, editItem }) {
  const id = editItem?.id ?? "";

  const { loading: typeLoading, data } = useGetAllCarInfoTypeQuery({
    query: ``
  });

  const carInfoTypes = data?.length ? optionGen(data) : [];

  const { loading, createCarInfo } = useCreateCarInfoMutation(["createCarInfo"]);

  const { loading: updating, updateCarInfo } = useUpdateCarInfoMutation(["updateCarInfo"]);

  const fields = [
    {
      label: "Car Info Type",
      name: "type",
      type: "select",
      placeholder: "Select a car info type",
      col: { md: 12 },
      rules: { required: "This is required field!" },
      options: carInfoTypes,
      isClearable: false
    },
    {
      label: "Car info name",
      name: "name",
      type: "text",
      placeholder: "Enter a car info name",
      col: { md: 12 },
      rules: { required: "This is required field!" }
    },
    {
      name: "parentComponent",
      type: "custom",
      customComponent: CarInfoParentField,
      col: { md: 12 }
    }
  ];

  const defaultValues = {
    name: editItem?.name ?? "",
    parent: editItem?.parent ? { label: editItem?.parent?.name, value: editItem?.parent?.id } : "",
    type: editItem?.car_info_type
      ? { label: editItem?.car_info_type?.name, value: editItem?.car_info_type?.id }
      : "",
    parent_type: editItem?.parent?.car_info_type
      ? { label: editItem?.parent?.car_info_type?.name, value: editItem?.parent?.car_info_type?.id }
      : ""
  };

  const onSubmit = async (data) => {
    const name = data?.name ?? "";
    const parent_id = data?.parent?.value ?? "";
    const car_info_type_id = data?.type?.value ?? "";

    const values = {
      name,
      parent_id,
      car_info_type_id
    };

    if (!!id) {
      const afterUpdated = await updateCarInfo({ id, ...values });

      if (afterUpdated?.status === 200) {
        toggle();
      }
      return;
    }

    const afterCreated = await createCarInfo({ ...values });
    if (afterCreated?.status === 201) {
      toggle();
    }
  };

  const isLoading = loading || updating || typeLoading;

  const title = `${!!id ? "Update" : "Create"} Car info`;

  return (
    <Modal modal={modal} toggle={toggle} title={title}>
      <Form
        fields={fields}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        submitbtnText={isLoading ? `${!!id ? "Updating..." : "Creating...."}` : title}
        toggle={toggle}
        loading={typeof isLoading === "boolean" ? isLoading : undefined}
      />
    </Modal>
  );
}
